/*  OVIA - sticky add to cart  ------------------------------------------
 *
 *  Replaces the theme's own <sticky-add-cart>, which could not be used as
 *  shipped: it renders its OWN form and adds the bare variant to the cart.
 *  On a pergola the customer configures sides, upgrades, accessories and
 *  installation, and the configurator posts all of those to /cart/add.js
 *  itself. Submitting the theme's form would drop every one of them and
 *  charge the base variant price.
 *
 *  So this bar never submits anything. It mirrors the real control:
 *    price   <- [data-ovc-total]      (the configurator's running total)
 *    button  -> clicks [data-ovc-atc] (the configurator's own button)
 *
 *  On products without the configurator (heaters, fans, walls) it falls
 *  back to the theme's price and the theme's add-to-cart button, which is
 *  correct there because there is nothing else to collect.
 *
 *  It reveals itself only once the real button has scrolled out of view,
 *  so the two are never on screen together.
 * --------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.__oviaStickyAtc) return;
  window.__oviaStickyAtc = true;

  var NAVY = '#082239';
  var BAR_ID = 'ovia-sticky-atc';

  /* Two claims shown above the button. Both are OVIA's own standing terms,
     taken from the trust line already used elsewhere in the theme. */
  var CLAIMS = [
    { icon: 'shield', text: '10–15 Year Warranty' },
    { icon: 'truck', text: 'Free U.S. Shipping' }
  ];

  var ICONS = {
    shield:
      '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" aria-hidden="true">' +
      '<path d="M10 2.2 4.3 4.4v4.3c0 3.5 2.3 6.8 5.7 8.1 3.4-1.3 5.7-4.6 5.7-8.1V4.4L10 2.2Z" ' +
      'stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    truck:
      '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" aria-hidden="true">' +
      '<path d="M2.4 5.2h8.1v7.6H2.4zM10.5 8h3l2.1 2.2v2.6h-5.1z" stroke="currentColor" ' +
      'stroke-width="1.4" stroke-linejoin="round"/><circle cx="6" cy="14.6" r="1.5" ' +
      'stroke="currentColor" stroke-width="1.4"/><circle cx="13.6" cy="14.6" r="1.5" ' +
      'stroke="currentColor" stroke-width="1.4"/></svg>',
    cart:
      '<svg viewBox="0 0 20 20" width="17" height="17" fill="none" aria-hidden="true">' +
      '<path d="M2.6 3h2l1.9 8.6h7.7l1.6-6.1H5.2" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="15.6" r="1.3" ' +
      'fill="currentColor"/><circle cx="13.8" cy="15.6" r="1.3" fill="currentColor"/></svg>'
  };

  var CSS =
    /* The theme's own bar is replaced wholesale, not restyled. */
    'sticky-add-cart{display:none !important}' +
    '#' + BAR_ID + '{' +
      'position:fixed;left:0;right:0;bottom:0;z-index:40;' +
      'background:#fff;border-top:1px solid rgba(8,34,57,.10);' +
      'box-shadow:0 -6px 24px rgba(8,34,57,.10);' +
      'padding:12px 16px calc(12px + env(safe-area-inset-bottom,0px));' +
      'font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;' +
      'transform:translateY(102%);transition:transform .22s ease;' +
      'pointer-events:none;' +
    '}' +
    '#' + BAR_ID + '.is-on{transform:translateY(0);pointer-events:auto}' +
    '@media (prefers-reduced-motion:reduce){#' + BAR_ID + '{transition:none}}' +
    '#' + BAR_ID + ' .osa__in{max-width:620px;margin:0 auto}' +
    '#' + BAR_ID + ' .osa__price{' +
      'text-align:center;font-size:21px;font-weight:700;letter-spacing:-.02em;' +
      'color:' + NAVY + ';line-height:1.15;margin:0 0 7px;' +
    '}' +
    '#' + BAR_ID + ' .osa__claims{' +
      'display:flex;justify-content:center;flex-wrap:wrap;gap:8px 22px;margin:0 0 11px;' +
    '}' +
    '#' + BAR_ID + ' .osa__claim{' +
      'display:inline-flex;align-items:center;gap:6px;' +
      'font-size:12.5px;line-height:1.2;color:rgba(8,34,57,.70);white-space:nowrap;' +
    '}' +
    '#' + BAR_ID + ' .osa__claim svg{flex:0 0 auto;color:' + NAVY + ';opacity:.85}' +
    '#' + BAR_ID + ' .osa__btn{' +
      'display:flex;align-items:center;justify-content:center;gap:9px;width:100%;' +
      'min-height:52px;padding:14px 20px;border:0;border-radius:999px;cursor:pointer;' +
      'background:' + NAVY + ';color:#fff;font:inherit;font-size:16px;font-weight:600;' +
      'letter-spacing:-.01em;transition:background .15s ease,opacity .15s ease;' +
    '}' +
    '#' + BAR_ID + ' .osa__btn:hover{background:#0d3a5c}' +
    '#' + BAR_ID + ' .osa__btn:focus-visible{outline:3px solid #adc8d9;outline-offset:2px}' +
    '#' + BAR_ID + ' .osa__btn[disabled]{opacity:.45;cursor:not-allowed}' +
    /* Desktop keeps the price and the button on one line. */
    '@media (min-width:750px){' +
      '#' + BAR_ID + '{padding:11px 24px}' +
      '#' + BAR_ID + ' .osa__in{max-width:1100px;display:flex;align-items:center;gap:24px}' +
      '#' + BAR_ID + ' .osa__left{flex:1 1 auto;text-align:left}' +
      '#' + BAR_ID + ' .osa__price{text-align:left;font-size:22px;margin:0 0 3px}' +
      '#' + BAR_ID + ' .osa__claims{justify-content:flex-start;margin:0}' +
      '#' + BAR_ID + ' .osa__btn{width:auto;min-width:260px;flex:0 0 auto}' +
    '}';

  /* ----- find the real controls ------------------------------------- */

  function realButton() {
    return (
      document.querySelector('[data-ovc-atc]') ||
      document.querySelector('.product-detail__buy-buttons button[type="submit"]:not([disabled])') ||
      document.querySelector('form[action^="/cart/add"] button[type="submit"]')
    );
  }

  function priceNode() {
    return (
      document.querySelector('[data-ovc-total]') ||
      document.querySelector('#ovia-main-price') ||
      document.querySelector('.product-detail__price .price')
    );
  }

  function priceText() {
    var n = priceNode();
    if (!n) return '';
    return (n.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* A price of zero means this is the $0 quote product, where an
     "Add to cart" bar would read as nonsense. Stay out of its way. */
  function priceIsReal(txt) {
    if (!txt) return false;
    var digits = txt.replace(/[^0-9]/g, '');
    return digits !== '' && Number(digits) > 0;
  }

  /* ----- build ------------------------------------------------------ */

  function claimHtml(c) {
    return '<span class="osa__claim">' + (ICONS[c.icon] || '') +
           '<span>' + c.text + '</span></span>';
  }

  function build(label) {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML =
      '<div class="osa__in">' +
        '<div class="osa__left">' +
          '<p class="osa__price" data-osa-price></p>' +
          '<div class="osa__claims">' + CLAIMS.map(claimHtml).join('') + '</div>' +
        '</div>' +
        '<button type="button" class="osa__btn" data-osa-btn>' +
          ICONS.cart + '<span data-osa-label></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('[data-osa-label]').textContent = label;
    return bar;
  }

  /* ----- run -------------------------------------------------------- */

  function start() {
    var btn = realButton();
    if (!btn) return;

    var label = (btn.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to Cart';
    if (label.length > 28) label = 'Add to Cart';

    var bar = build(label);
    var priceEl = bar.querySelector('[data-osa-price]');
    var barBtn = bar.querySelector('[data-osa-btn]');
    var visible = false;

    function sync() {
      var txt = priceText();
      priceEl.textContent = txt;

      var live = realButton();
      var ok = priceIsReal(txt) && !!live && !live.disabled;
      barBtn.disabled = !live || live.disabled;

      /* Never show an empty or zero price, and never show the bar while
         the real button is still on screen. */
      if (visible && ok) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    }

    barBtn.addEventListener('click', function () {
      var live = realButton();
      if (!live || live.disabled) return;
      live.click();
      /* Bring the real control into view so any validation message it
         shows - the terms checkbox, a missing size - is actually read. */
      try {
        live.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (e) {
        live.scrollIntoView();
      }
    });

    /* Reveal once the real button has left the viewport. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = !entries[0].isIntersecting;
          sync();
        },
        { rootMargin: '0px 0px -10px 0px' }
      ).observe(btn);
    } else {
      window.addEventListener('scroll', function () {
        var r = btn.getBoundingClientRect();
        visible = r.bottom < 0 || r.top > window.innerHeight;
        sync();
      }, { passive: true });
    }

    /* The configurator rewrites the total on every choice. */
    var watch = priceNode();
    if (watch && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(watch, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
    document.addEventListener('change', sync, true);
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);

    sync();
  }

  function boot() {
    /* The configurator renders after its own script runs, so give the
       page a moment before deciding there is no button. */
    var tries = 0;
    (function look() {
      if (realButton()) { start(); return; }
      if (++tries > 20) return;
      setTimeout(look, 250);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
